"use client";

import { ReactNode } from "react";
import { motion } from "framer-motion";
import Heading from "~/componentsDS/Typography/Heading";
import Paragraph from "~/componentsDS/Typography/Paragraph";

type StepCardProps = {
    stepIndex: number;
    title: string;
    description: ReactNode;
    icon: ReactNode;
    id: string;
    labelledBy: string;
    skipInitialAnimation?: boolean;
};

const StepCard = ({ stepIndex, title, description, icon, id, labelledBy, skipInitialAnimation }: StepCardProps) => {
    return (
        <motion.div
            role="tabpanel"
            id={id}
            aria-labelledby={labelledBy}
            initial={skipInitialAnimation ? false : { opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -8 }}
            transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
            className="bg-pureWhite rounded-3xl px-6 py-4 shadow-[-18px_24px_8px_0_rgba(0,0,0,0),_-12px_15px_8px_0_rgba(0,0,0,0.01),_-7px_9px_6px_0_rgba(0,0,0,0.05),_-3px_4px_5px_0_rgba(0,0,0,0.09),_-1px_1px_3px_0_rgba(0,0,0,0.1)]"
        >
            <div className="flex gap-2">
                <div className="
                    inline-flex justify-center items-center shrink-0 w-8 h-8 pt-1
                    font-suisseBP text-[18px] leading-[1.1] text-pureWhite
                    bg-primary300
                    rounded-full overflow-hidden
                ">
                    {stepIndex + 1}
                </div>
                <div className="shrink-0 w-[80px] h-[80px] md:w-[140px] md:h-[140px] flex items-center justify-center">
                    {icon}
                </div>
                <div className="flex flex-col gap-4 flex-1 min-w-0 text-primary500">
                    <Heading as="h3" size="xs" weight="400">
                        {title}
                    </Heading>
                    <Paragraph size="lg">
                        {description}
                    </Paragraph>
                </div>
            </div>
        </motion.div>
    );
};

export default StepCard;
